import React from 'react';

import Modal from 'components/modal';
import localizedStrings from 'localization';
import { CancelButton } from 'modules/challenge/components';
import {
  AddQuestFormButtons,
  AddQuestPrompt,
} from 'modules/settings/components';

type ActiveQuestModalProps = {
  open: boolean;
  close: () => void;
};

const ActiveQuestModal = ({ open, close }: ActiveQuestModalProps) => {
  return (
    <Modal
      open={open}
      width={'500px'}
      title={localizedStrings.quests}
      hideCloseButton>
      <>
        <AddQuestPrompt>
          This is your active quest.
        </AddQuestPrompt>
        <AddQuestFormButtons>
          <CancelButton type="button" onClick={close}>
            {localizedStrings.ok}
          </CancelButton>
        </AddQuestFormButtons>
      </>
    </Modal>
  );
};

export default ActiveQuestModal;

